import { render, staticRenderFns } from "./QuizOverview.vue?vue&type=template&id=3dcb2d0a&"
import script from "./QuizOverview.vue?vue&type=script&lang=js&"
export * from "./QuizOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports